<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;background-color: #FAFAFA;">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 10%">
                            <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;">
                                <CCard class="border-radius-16px p-4 mb-5" style="border:none">
                                    <div class="text-center">
                                        <h3 class="custom-32px-500 text-center font-color-171717">Confirmation Package</h3>
                                        <p class="custom-16px-400">Review your subscription below</p>
                                    </div>
                                    <CCard class="border-radius-16px p-4 mb-5">
                                        <div class="mt-3">
                                            <CRow>
                                                <CCol sm="8">
                                                    <div class="ml-3">
                                                        <h4 class="custom-16px-500 mt-3 font-inter font-color-171717"><strong>Personal Details</strong></h4>
                                                        <label class="mt-3 font-inter font-color-171717"><strong>Full Name</strong></label>
                                                        <input type="text" v-model="user.name" class="custom-input-app" disabled />
                                                        <CRow>
                                                            <CCol sm="6">
                                                                <label class="mt-3 font-inter font-color-171717"><strong>Email Address</strong></label>
                                                                <input type="text" v-model="user.email" class="custom-input-app" disabled />
                                                            </CCol>
                                                            <CCol sm="6">
                                                                <label class="mt-3 font-inter font-color-171717"><strong>Phone Number</strong></label>
                                                                <input type="text" v-model="user.phone" class="custom-input-app" disabled />
                                                            </CCol>
                                                        </CRow>
                                                        <div class="text-left mt-5">
                                                            <div v-if="amountPackage > 0">
                                                                <span class="custom-border-purple p-2 text-left text-white" @click="ConvertExchangeRate()">
                                        <label class="ml-2 mr-2">Continue to pay</label>
                                      </span>
                                                            </div>
                                                            <div v-else>
                                                                <span class="custom-border-purple p-2 text-left text-white" @click="SubmitPackageFree()">
                                        <label class="ml-2 mr-2">Continue to subscribe</label>
                                      </span>
                                                            </div>
                                                            <br />
                                                        </div>
                                                    </div>
                                                </CCol>
                                                <CCol sm="4">
                                                    <CCard class="b-20">
                                                        <div class="m-3">
                                                            <h4 class="custom-20px-500 font-inter font-color-171717"><strong>Order Summary</strong></h4>
                                                            <CRow v-for="item in packages" :key="item.packageId">
                                                                <CCol sm="6">
                                                                    <h4 class="mt-2">{{ item.packageName }}</h4>
                                                                </CCol>
                                                                <CCol sm="6">
                                                                    <h4 class="mt-2 custom-24px-500 text-right">
                                                                        ${{ item.packagePrice }}/<label v-for="(items, index) in item.PackageDetails" :key="items.packageDetailId" class="custom-16px-500">
                                            <div v-if="index == 0">{{ items.Type }}</div>
                                          </label>
                                                                    </h4>
                                                                </CCol>
                                                                <CCol sm="12">
                                                                    <ul v-for="items in item.PackageDetails" :key="items.packageDetailId">
                                                                        <li style="text-align: left;">{{ items.Description }}</li>
                                                                    </ul>
                                                                    <h4 class="custom-14px-500">Discount Code</h4>
    
    
                                                                    <div class="input-button-container">
                                                                        <input type="text" v-model="discount" class="custom-input-app" @input="onDiscountInput" />
                                                                        <img src="../assets/img/btnNext.png" class="choose-voucher-button mr-2" @click="OpenVoucher" style="max-width:40px" />
                                                                    </div>
    
                                                                    <CRow>
                                                                        <CCol sm="6" class="mt-4">
                                                                            Subtotal
                                                                        </CCol>
                                                                        <CCol sm="6" class="text-right mt-4">
                                                                            ${{ item.packagePrice }}
                                                                        </CCol>
                                                                        <CCol sm="6" class="mt-2">
                                                                            Discount
                                                                        </CCol>
                                                                        <CCol sm="6" class="text-right mt-2">
                                                                            ${{ discountAmount }}
                                                                        </CCol>
                                                                        <CCol sm="12" class="mt-2">
                                                                            <hr />
                                                                        </CCol>
                                                                        <CCol sm="6" class="mt-2">
                                                                            Total
                                                                        </CCol>
                                                                        <CCol sm="6" class="text-right mt-2">
                                                                            ${{ totalPrice }}
                                                                        </CCol>
                                                                    </CRow>
                                                                </CCol>
                                                            </CRow>
                                                        </div>
                                                    </CCard>
                                                </CCol>
                                            </CRow>
                                        </div>
                                    </CCard>
                                    <div style="clear:both"></div>
                                </CCard>
                            </CCol>
                        </div>
                    </CCol>
                </CRow>
            </CCol>
        </CCol>
        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Successfully Subscribe Package
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px">
                        <span class="ml-2 mr-2">OK</span>
                    </CButton>
                </div>
            </div>
        </div>
        <div v-if="isPopupVoucher" class="popup-all backdrop-all">
            <div class="popup-all1">
                <div class="text-right">
                <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup1" />
            </div>
                <!-- Popup content -->
                <div class="text-center">
                    <h4 class="custom-30px-600">Discount Code</h4>
                    <CInput type="text" v-model="searchQuery" />
                    <CCard class="b-16" v-for="item in filteredVouchers" :key="item.Id">
                        <CRow>
                            <CCol sm="2">
                                <div class="text-center ml-1 mt-2">
                                    <input type="radio" :value="item.Code" v-model="selectedVoucherCode" />
                                </div>
                            </CCol>
                            <CCol sm="10">
                                <h3 class="custom-16px-700 text-left font-inter font-color-171717 mt-2">{{ item.Title }}</h3>
                                <h4 class="custom-12px-400 text-left">{{ item.SubTitle }}</h4>
                                <div class="row">
                                    <div style="width:50%">
                                        <label class="custom-12px-500 text-left">Exp Date <label class="text-danger">{{ item.ValidDate | moment("DD-MMM-YYYY") }}</label></label>
                                    </div>
                                    <div style="width:50%">
                                        <h4 class="custom-12px-400 text-right mr-4">{{ item.Code }} <img style="max-width:12px" src="../assets/img/copy.png" /></h4>
                                    </div>
                                </div>
                            </CCol>
                        </CRow>
                    </CCard>
                    <CButton class="custom-border-purple mt-4 text-white" @click="useSelectedVoucherCode">
                        <span class="ml-2 mr-2">Use Voucher Code</span>
                    </CButton>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';

Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");

import _ from "lodash";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,
            backgroundGenie,
            isPopupSuccess: false,
            user: {},
            targetCurrency: "",
            packages: [],
            amountPackage: this.$route.query.amount,
            voucher: [],
            isPopupVoucher: false,
            selectedVoucherCode: '',
            searchQuery: '',
            discount: '',
            discountAmount: 0,
            actualAmountDolar: 0,
        };
    },

    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser(); // Fetch the user details first
                await this.GetDetailPackage();
                await this.GetListVoucher();
                this.ConvertActualExchangeRate();
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            console.error("Error during authentication:", error);
            // Handle the error here
        }
    },

    computed: {
        filteredVouchers() {
            // Assuming you want to filter vouchers based on the search query
            return this.voucher.filter(item =>
                item.Title.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        },
        totalPrice() {
      // Assuming you have only one package and you want to show the total price after discount
      if (this.packages.length > 0) {
        return this.packages[0].packagePrice - this.discountAmount;
      }
      return 0;
    },
    },

    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetDetailPackage() {
            try {
                const response = await this.$API.get(this.$GetPackageCandidateById + "?id=" + this.$route.query.packageId);
                if (response.status === 200) {
                    this.packages = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        ConvertExchangeRate() {
            this.targetCurrency = this.user.currency;
            this.priceInUSD = this.totalPrice;

            console.log("targetcurrency" + this.targetCurrency);
            console.log("priceInUSD" + this.priceInUSD);
            // Fetch exchange rate for USD to targetCurrency
            fetch(`https://api.exchangerate-api.com/v4/latest/USD`)
                .then(response => response.json())
                .then(data => {
                    const exchangeRate = data.rates[this.targetCurrency];
                    if (exchangeRate) {
                        const equivalentPrice = (this.priceInUSD * exchangeRate).toFixed(2);
                        // alert(`Equivalent price in ${this.targetCurrency}: ${equivalentPrice}`);
                        this.SubmitPackage(equivalentPrice);
                    } else {
                       // alert(`Failed to fetch exchange rate for ${this.targetCurrency}`);
                    }
                })
                .catch(error => {
                    console.error('Error fetching exchange rate:', error);
                });
        },
        ConvertActualExchangeRate() {
            this.targetCurrency = this.user.currency;
            this.priceInUSD = this.amountPackage;

            console.log("targetcurrency" + this.targetCurrency);
            console.log("priceInUSD" + this.priceInUSD);
            // Fetch exchange rate for USD to targetCurrency
            fetch(`https://api.exchangerate-api.com/v4/latest/USD`)
                .then(response => response.json())
                .then(data => {
                    const exchangeRate = data.rates[this.targetCurrency];
                    if (exchangeRate) {
                        const equivalentPriceAmount = (this.priceInUSD * exchangeRate).toFixed(2);
                         //alert(`Equivalent price in ${this.targetCurrency}: ${equivalentPriceAmount}`);
                        this.actualAmountDolar = equivalentPriceAmount;
                    } else {
                       // alert(`Failed to fetch exchange rate for ${this.targetCurrency}`);
                    }
                })
                .catch(error => {
                    console.error('Error fetching exchange rate:', error);
                });
        },
        SubmitPackage(equivalentPrice) {
            const formData = new FormData();
            formData.append("userId", this.user.id);
            formData.append("PackageId", this.$route.query.packageId);
            formData.append("amount", this.actualAmountDolar);
            formData.append("discount", this.discountAmount);
            formData.append("total", equivalentPrice);
            formData.append("phone", this.user.phone);
            formData.append("amountUSD", this.totalPrice);
            formData.append("code", this.discount);
            

            this.$API
                .post(this.$SubscribePackage, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            this.amount = this.$route.query.amount;
                            this.billId = response.data;
                            window.open(
                                "https://www.billplz.com/bills/" + this.billId,
                                "_self"
                            );
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        SubmitPackageFree() {
            const formData = new FormData();
            formData.append("userId", this.user.id);
            formData.append("PackageId", this.$route.query.packageId);
            formData.append("amount", 0);
            formData.append("phone", this.user.phone);

            this.$API
                .post(this.$SubscribePackagesFree, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            this.isPopupSuccess = true;
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccess() {
            this.isPopupSuccess = false;
        },
        async GetListVoucher() {
            try {
                const response = await this.$API.get(this.$GetListVoucher + "?userId=" + this.user.id);
                if (response.status === 200 && response.data) {
                    this.voucher = response.data;
                }
            } catch (error) {
                console.error("Error fetching user info:", error);
            }
        },
        OpenVoucher() {
            console.log("OpenVoucher called"); // Debugging log
            this.isPopupVoucher = true;
        },
        useSelectedVoucherCode() {
            this.discount = this.selectedVoucherCode;
            this.isPopupVoucher = false;
            this.GetAmountVoucher(this.discount);
        },
        async GetAmountVoucher(discount) {
            console.log("dd" + discount);
      // Ensure discount is not null or empty before making API call
      if (!this.discount) return;

      // Split the voucherAmount to handle multiple voucher codes
      const voucherCodes = this.discount.split(',').map(code => code.trim()).join(',');

      try {
        const response = await this.$API.get(`${this.$GetVoucherAmount}?codes=${encodeURIComponent(voucherCodes)}`, {
          withCredentials: true,
        });

        if (response.status === 200) {
          const amounts = response.data;
          // Assuming response.data contains the amount, update discountAmount
          this.discountAmount = amounts; // Update this based on how your API returns the data
          this.submitVoucher(amounts); // If you need to do something with amounts
        }
      } catch (error) {
        console.error("Error fetching voucher amounts:", error);
      }
    },
    closePopup1()
    {
        this.isPopupVoucher = false;
    },
    onDiscountInput: _.debounce(function() {
      if (this.discount) {
        this.GetAmountVoucher();
      }
    }, 500), // Adjust the debounce time as needed
    },
};
</script>
  
<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.input-button-container {
    position: relative;
    width: fit-content;
}

.custom-input-app {
    padding-right: 50px;
    /* Adjust this based on button width */
}

.choose-voucher-button {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
</style>
  